import * as Types from '../constants/Types';

export const getTransactions = (filters) => ({ type: Types.CASH_FLOW_GET_TRANSACTION_ACTION, filters });
export const setTransactions = (transactions) => ({ type: Types.CASH_FLOW_GET_TRANSACTION_SUCCESS, transactions});

export const getAccounts = (filters) => ({ type: Types.CASH_FLOW_GET_ACCOUNT_ACTION, filters });
export const setAccounts = (accounts) => ({ type: Types.CASH_FLOW_GET_ACCOUNT_SUCCESS, accounts});

export const getTransactionsImbalance = (filters) => ({ type: Types.CASH_FLOW_GET_TRANSACTION_IMBALANCE_ACTION, filters });
export const setTransactionsImbalance = (transactionImbalances) => ({ type: Types.CASH_FLOW_GET_TRANSACTION_IMBALANCE_SUCCESS, transactionImbalances});

export const createReceiptPayslipDetail = (receiptPayslip) => ({ type: Types.RECEIPTS_PAYSLIP_ACTION, receiptPayslip });
